export const checkAmount = (amountOption, amountValue) => {
  let hasError = false;
  if (amountOption?.min && amountValue < +amountOption?.min) {
    hasError = true;
  }
  if (amountOption?.max && amountValue > +amountOption?.max) {
    hasError = true;
  }
  return hasError;
}